import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import './_YatLogo.scss';
import { Link } from 'react-router-dom';

const YatLogo: FC = () => {
    const { t } = useTranslation(['translation']);
    return (
        <Link to="/">
            <img src="/assets/img/yat-hand-purple-outline.svg" alt={t('yat')} className="yat-page_logo" />
        </Link>
    );
};

export default YatLogo;
